<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <h1 class="sr-only">Marketing Case Studies — ASO, User Acquisition, and Retention Outcomes</h1>
    <app-hero-section
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`" videoSrc="/video/marketing-case-studies.mp4"
        align="left" [titleHtml]="heroTitleHtml"
        subcopy="Real results from real apps — see how our ASO, user acquisition, and retention work moved downloads, rankings, and revenue."
        text="case studies">
        <app-button hero-cta buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
    </app-hero-section>
    <app-projects></app-projects>
    <div class="mt-[150px]">
        <app-info-card>
            <div class="flex justify-center">
                <img src="images/landing/why-semnexus.svg" alt="why semnexus" class="h-[45px] sm:h-[50px]" />
            </div>
            <div class="mt-[24px] px-4 sm:px-[10%] text-center text-sm sm:text-base">
                At Semnexus, we help your app achieve high rankings, increase downloads, and maximize ROI.
                Our comprehensive app marketing services cover App Store Optimization, competitor analysis, ad copy, and
                growth strategies tailored for your success. Whether you're launching a new app or scaling an existing
                one, we deliver high-impact marketing without the high costs. Let's make your app go viral!
            </div>
        </app-info-card>
    </div>
    <app-connect></app-connect>
</app-background>